/* ============================================================
   BLINKIE PETS — match quiz
   Intro -> questions -> scored result. Content is editable in
   the theme editor; scoring mirrors the original brief:
   weighted votes, a "force" override, and a lifestyle tie-break.
   ============================================================ */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var f = format || '${{amount}}';
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(num) || num == null) num = 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var token = (f.match(rx) || [null, 'amount'])[1];
    var val;
    switch (token) {
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      default: val = fmt(cents, 2);
    }
    return f.replace(rx, val);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---- Klaviyo client-side subscribe (optional) ---- */
  function klaviyoSubscribe(kl, email, props) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(kl.publicKey);
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email, properties: props || {} } } }
        },
        relationships: { list: { data: { type: 'list', id: kl.listId } } }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('klaviyo ' + res.status);
      return true;
    });
  }

  function initQuiz(root) {
    var quizzes = (root || document).querySelectorAll('[data-bp-quiz]');
    quizzes.forEach(function (quiz) {
      if (quiz.dataset.bpQuizBound) return;
      quiz.dataset.bpQuizBound = '1';

      var dataEl = quiz.querySelector('[data-bp-quiz-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var cfg = data.config || {};
      var questions = (data.questions || []).map(function (q) {
        return { title: q.title, sub: q.sub, options: (q.options || []).filter(function (o) { return o.label; }) };
      });
      var results = data.results || {};
      var resultKeys = Object.keys(results);

      var intro = quiz.querySelector('[data-bp-quiz-intro]');
      var stage = quiz.querySelector('[data-bp-quiz-stage]');
      var startBtn = quiz.querySelector('[data-bp-quiz-start]');

      var state = { answers: {}, cologne: !!cfg.colognePrechecked, added: false };

      /* ---- Scoring ---- */
      function computeMatch() {
        // Force override
        for (var i = 0; i < questions.length; i++) {
          var pi = state.answers[i];
          if (pi == null) continue;
          var opt = questions[i].options[pi];
          if (opt && opt.forces && opt.match && opt.match !== 'none') return opt.match;
        }
        var score = { celebrity: 0, cuddly: 0, zoomy: 0 };
        var lifestyle = 'unsure';
        questions.forEach(function (q, qi) {
          var pi = state.answers[qi];
          if (pi == null) return;
          var opt = q.options[pi];
          if (!opt) return;
          if (opt.lifestyle && opt.lifestyle !== 'none') lifestyle = opt.lifestyle;
          if (opt.match && score.hasOwnProperty(opt.match)) score[opt.match] += Number(opt.weight || 0);
        });
        var max = Math.max(score.celebrity, score.cuddly, score.zoomy);
        var leaders = ['celebrity', 'cuddly', 'zoomy'].filter(function (k) { return score[k] === max; });
        if (leaders.length === 1) return leaders[0];
        if (lifestyle === 'indoor' && leaders.indexOf('cuddly') >= 0) return 'cuddly';
        if (lifestyle === 'outdoor' && leaders.indexOf('zoomy') >= 0) return 'zoomy';
        if (leaders.indexOf('celebrity') >= 0) return 'celebrity';
        return leaders[0];
      }

      /* ---- Rendering ---- */
      function show(el) { intro.hidden = (el !== 'intro'); stage.hidden = (el === 'intro'); }

      function renderQuestion(qi) {
        show('stage');
        var q = questions[qi];
        var dots = '';
        for (var d = 0; d < questions.length; d++) {
          dots += '<span class="bp-quiz__dot" data-on="' + (d <= qi ? 'true' : 'false') + '"></span>';
        }
        var opts = q.options.map(function (o, oi) {
          return '<button type="button" class="bp-quiz__opt" data-opt="' + oi + '">' + esc(o.label) + '</button>';
        }).join('');
        var back = qi > 0 ? '<div class="bp-quiz__back"><button type="button" data-back>&larr; Back</button></div>' : '';
        stage.innerHTML =
          '<div class="bp-quiz__qhead">' +
            '<div class="bp-quiz__progress"><span class="bp-quiz__plabel">' + esc(cfg.progressPrefix || 'Question') + ' ' + (qi + 1) + ' of ' + questions.length + '</span>' +
            '<div class="bp-quiz__dots">' + dots + '</div></div>' +
            '<h2 class="bp-quiz__qtitle">' + esc(q.title) + '</h2>' +
            (q.sub ? '<p class="bp-quiz__qsub">' + esc(q.sub) + '</p>' : '') +
          '</div>' +
          '<div class="bp-quiz__opts" role="radiogroup" aria-label="' + esc(q.title) + '">' + opts + '</div>' + back;
        quiz.setAttribute('data-bg', 'cream');

        stage.querySelectorAll('[data-opt]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            state.answers[qi] = parseInt(btn.getAttribute('data-opt'), 10);
            if (qi + 1 < questions.length) renderQuestion(qi + 1);
            else renderResult();
          });
        });
        var backBtn = stage.querySelector('[data-back]');
        if (backBtn) backBtn.addEventListener('click', function () { renderQuestion(qi - 1); });
      }

      function renderResult() {
        show('stage');
        var key = computeMatch();
        var r = results[key] || results[resultKeys[0]];
        if (!r) return;
        quiz.setAttribute('data-bg', key);
        state.added = false;

        var img = r.image
          ? '<img class="bp-img" src="' + esc(r.image) + '" alt="' + esc(r.name) + '">'
          : '<div class="bp-img-ph">' + esc(r.name) + ' photo</div>';
        var reasons = (r.reasons || []).map(function (t) {
          return '<span><i>&#10022;</i> ' + esc(t) + '</span>';
        }).join('');
        var cologneRow = (cfg.cologneId && !cfg.reserveUrl)
          ? '<button type="button" class="bp-quiz__cologne' + (state.cologne ? ' on' : '') + '" data-cologne aria-pressed="' + state.cologne + '">' +
              '<span class="bp-quiz__check"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5"><path d="M4 12 L10 18 L20 6"></path></svg></span>' +
              '<span style="display:flex;flex-direction:column;gap:2px;">' +
                '<span style="font-size:13.5px;font-weight:700;color:#5D3A4C;">' + esc(cfg.cologneLabel || 'Add cologne') + '</span>' +
                '<span style="font-size:12px;color:#6E9384;font-weight:600;letter-spacing:.06em;text-transform:uppercase;">Completes the ritual</span>' +
              '</span></button>'
          : '';
        var fullLink = r.url ? '<a href="' + esc(r.url) + '">See the full product</a>' : '<span></span>';
        var kl = cfg.klaviyo || {};
        var optin = (kl.enabled && kl.publicKey && kl.listId)
          ? '<form class="bp-quiz__optin" data-optin novalidate>' +
              (kl.heading ? '<p class="bp-quiz__optin-h">' + esc(kl.heading) + '</p>' : '') +
              '<div class="bp-quiz__optin-row">' +
                '<input type="email" name="email" required autocomplete="email" placeholder="Your email" class="bp-quiz__optin-input" aria-label="Email address">' +
                '<button type="submit" class="bp-quiz__optin-btn">' + esc(kl.button || 'Send it to me') + '</button>' +
              '</div>' +
              (kl.disclaimer ? '<p class="bp-quiz__optin-note">' + esc(kl.disclaimer) + '</p>' : '') +
              '<p class="bp-quiz__optin-msg" data-optin-msg hidden></p>' +
            '</form>'
          : '';

        stage.innerHTML =
          '<div class="bp-quiz__rhead"><p class="bp-eyebrow" style="letter-spacing:.2em;">Your baby is</p><h2 class="bp-quiz__persona">' + esc(r.persona) + '</h2></div>' +
          '<div class="bp-quiz__card">' +
            '<div class="bp-quiz__cardimg"><div>' + img + '</div></div>' +
            '<div>' +
              '<h3 class="bp-quiz__pname">' + esc(r.name) + '</h3>' +
              '<p class="bp-quiz__price">' + esc(r.price) + '</p>' +
              '<p class="bp-quiz__rintro">' + esc(r.intro) + '</p>' +
              '<div class="bp-quiz__reasons">' + reasons + '</div>' +
              (r.scent ? '<p class="bp-quiz__scent">And then, the scent. ' + esc(r.scent) + '</p>' : '') +
              cologneRow +
              '<button type="button" class="bp-quiz__atc" data-atc></button>' +
              '<div class="bp-quiz__rlinks">' + fullLink + '<button type="button" class="bp-quiz__retake" data-retake>Retake the quiz</button></div>' +
              optin +
            '</div>' +
          '</div>';

        var atc = stage.querySelector('[data-atc]');
        var cologneBtn = stage.querySelector('[data-cologne]');

        function total() { return (Number(r.priceCents) || 0) + (state.cologne && cfg.cologneId ? Number(cfg.colognePrice) || 0 : 0); }
        function atcLabel() {
          if (cfg.reserveUrl) return cfg.reserveLabel || 'Reserve my match';
          if (state.added) return cfg.addedLabel || 'Added to cart';
          var t = total();
          return t > 0 ? 'Add to Cart · ' + formatMoney(t, cfg.moneyFormat) : 'Add to Cart';
        }
        function paint() { if (atc) atc.textContent = atcLabel(); }
        paint();

        if (cologneBtn) cologneBtn.addEventListener('click', function () {
          state.cologne = !state.cologne;
          cologneBtn.classList.toggle('on', state.cologne);
          cologneBtn.setAttribute('aria-pressed', state.cologne);
          paint();
        });

        if (atc) atc.addEventListener('click', function () {
          // Reserve mode: funnel the match to the reservation page (preorder via WOD + PayMongo).
          if (cfg.reserveUrl) {
            var sep = cfg.reserveUrl.indexOf('?') === -1 ? '?' : '&';
            window.location.href = cfg.reserveUrl + sep + 'match=' + encodeURIComponent(key);
            return;
          }
          if (state.added) return;
          if (!r.variantId) { if (r.url) window.location.href = r.url; return; }
          var items = [{ id: r.variantId, quantity: 1 }];
          if (state.cologne && cfg.cologneId) items.push({ id: cfg.cologneId, quantity: 1 });
          var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          atc.disabled = true;
          fetch(addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (res) {
            if (!res.ok) { return res.json().then(function (e) { throw e; }); }
            return res.json();
          })
            .then(function () { window.location.href = cartUrl; })
            .catch(function () { atc.disabled = false; atc.textContent = 'Sold out — tap to view'; setTimeout(function(){ if (r.url) window.location.href = r.url; }, 900); });
        });

        var retake = stage.querySelector('[data-retake]');
        if (retake) retake.addEventListener('click', function () {
          state.answers = {}; state.added = false; quiz.setAttribute('data-bg', 'cream'); show('intro');
        });

        var optinForm = stage.querySelector('[data-optin]');
        if (optinForm) optinForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var input = optinForm.querySelector('input[type=email]');
          var msg = optinForm.querySelector('[data-optin-msg]');
          var btn = optinForm.querySelector('button[type=submit]');
          var email = (input.value || '').trim();
          if (!email || email.indexOf('@') < 1) { input.focus(); return; }
          btn.disabled = true; btn.textContent = 'Sending…';
          // Save the quiz match to the Klaviyo profile so flows can segment on it.
          klaviyoSubscribe(kl, email, { blinkie_match: key, blinkie_persona: r.persona, blinkie_product: r.name })
            .then(function () {
              optinForm.innerHTML = '<p class="bp-quiz__optin-success">' + esc(kl.success || "You're in.") + '</p>';
            })
            .catch(function () {
              btn.disabled = false; btn.textContent = kl.button || 'Send it to me';
              if (msg) { msg.hidden = false; msg.textContent = 'Something went wrong. Please try again.'; }
            });
        });
      }

      if (startBtn) startBtn.addEventListener('click', function () {
        state.answers = {};
        if (questions.length) renderQuestion(0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initQuiz(document); });
  } else {
    initQuiz(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initQuiz(e.target); });
})();
